module.exports = __webpack_public_path__ + "img/emoji-sad.8c798897.png";